var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "107px",
    height: "46px",
    viewBox: "0 0 107 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TTI") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fontFamily: "RalewayRoman-SemiBold, Raleway",
    fontSize: 64,
    fontWeight: 500,
    letterSpacing: 0.219606588
  }, /*#__PURE__*/React.createElement("g", {
    id: "512x512",
    transform: "translate(-91.000000, -218.000000)",
    fill: "#C770F0"
  }, /*#__PURE__*/React.createElement("text", {
    id: "TTI."
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 91.5905162,
    y: 264
  }, "TTI."))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTti);
export default __webpack_public_path__ + "static/media/TTI.d0ce7e0333c459b61488143d7645528f.svg";
export { ForwardRef as ReactComponent };